function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React, { useCallback, useContext, useEffect } from 'react';
import styles from './HorizontalScroll.module.scss';
import HorizontalScrollContext from './HorizontalScrollContext';
import useDisabledScroll from './useDisabledScroll';
export default function withHorizontalScroll() {
  return function (TableComponent) {
    return function (_ref) {
      var sticksTo = _ref.sticksTo,
        props = _objectWithoutProperties(_ref, ["sticksTo"]);
      var context = useContext(HorizontalScrollContext);
      context.sticksTo = sticksTo;
      var containerRef = context.containerRef,
        overflowRef = context.overflowRef,
        tableRef = context.tableRef,
        width = context.width;
      var disabled = useDisabledScroll();
      var handleKeyDown = useCallback(function (e) {
        if (!!context.onKeyDown) {
          context.onKeyDown(e);
        }
      }, [context]);
      var handleFocus = useCallback(function (e) {
        if (!!context.onFocus) {
          context.onFocus(e);
        }
      }, [context]);
      useEffect(function () {
        // Trigger sticky column re-calc
        var event = document.createEvent('HTMLEvents');
        event.initEvent('resize', true, false);
        window.dispatchEvent(event);
      }, [props.data]);
      return disabled ? /*#__PURE__*/React.createElement(TableComponent, Object.assign({
        ref: tableRef,
        sticksTo: sticksTo
      }, props)) : /*#__PURE__*/React.createElement("div", {
        className: styles['overflow'],
        onFocus: handleFocus,
        onKeyDown: handleKeyDown,
        ref: overflowRef
      }, /*#__PURE__*/React.createElement("div", {
        ref: containerRef,
        className: styles['container'],
        style: {
          width: width
        }
      }, /*#__PURE__*/React.createElement(TableComponent, Object.assign({
        ref: tableRef
      }, props))));
    };
  };
}